import { Suspense } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { BasicLoader } from '@helpers/Loaders';
import TeamPage from '@features/TeamPage/TeamPage';
import PlayerPage from '@features/Player/PlayerPage';
import useHandle from './useHandle';
import { PageType } from './handle.d';

const Handle = () => {
  const { handle } = useParams<{
    handle: string;
  }>();

  const location = useLocation();
  const { activeId, pageType } = useHandle(handle, location?.search);

  return (
    <Suspense fallback={<BasicLoader fullPage />}>
      {pageType === PageType.TEAM && (
        <TeamPage key={`team-${activeId}`} teamId={activeId} fromInvite={''} />
      )}
      {(pageType === PageType.PLAYER || pageType === PageType.TEAMPLAYER) && (
        <PlayerPage
          claimed={pageType === PageType.PLAYER}
          playerId={activeId}
        />
      )}
    </Suspense>
  );
};

export default Handle;
